var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body",class:[_vm.bodyClasses],style:({
              'padding': _vm.bodyPadding,
              'overflow-y': _vm.scrollY ? 'scroll' : 'hidden',
              'overflow-x': _vm.scrollX ? 'scroll' : 'hidden'
          })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }